import Box from '@mui/material/Box';
import { Accordion } from '@raisin/components-lib';
import { getDomainConfig } from '@raisin/cp-utils';
import React from 'react';
import { CustomLink } from '../../../../components/CustomLink';
import { resolveUrlWithLocale } from '../../../../utils/helpers';
import * as S from './styles';
const AccordionContentLinks = ({ footerLinks, locale }) => {
    const { basePath } = getDomainConfig(locale);
    if (!footerLinks.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null, footerLinks.map((section) => {
        var _a;
        return (React.createElement(Accordion, { key: section === null || section === void 0 ? void 0 : section.heading, content: [
                {
                    key: section === null || section === void 0 ? void 0 : section.heading,
                    details: (React.createElement(Box, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        } }, (_a = section.link) === null || _a === void 0 ? void 0 : _a.map((link) => (React.createElement(CustomLink, { href: resolveUrlWithLocale(link === null || link === void 0 ? void 0 : link.href, basePath), key: link === null || link === void 0 ? void 0 : link.title },
                        React.createElement(S.Anchor, { href: resolveUrlWithLocale(link === null || link === void 0 ? void 0 : link.href, basePath) },
                            React.createElement(S.Typography, { variant: "body1" }, link === null || link === void 0 ? void 0 : link.title))))))),
                    title: section === null || section === void 0 ? void 0 : section.heading,
                },
            ], testId: "accordion-content-links" }));
    })));
};
export default AccordionContentLinks;
//# sourceMappingURL=AccordionContentLinks.js.map